// /forgot-password
import { API } from "../../apiSlice";

export const resetPasswordApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    resetPassword: builder.mutation({
      query: (data) => {
        return {
          url: "users/reset-password",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useResetPasswordMutation } = resetPasswordApiSlice;
